import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList} from '@angular/core';
import {BzgButtonToggleComponent} from '../button-toggle/button-toggle.component';


@Component({
  selector: 'bzg-button-toggle-group',
  templateUrl: './button-toggle-group.component.html',
  styleUrls: ['./button-toggle-group.component.scss']
})
export class BzgButtonToggleGroupComponent implements AfterContentInit {


  @ContentChildren(BzgButtonToggleComponent) buttons: QueryList<BzgButtonToggleComponent>;

  @Output() change = new EventEmitter();

  private _value: any;

  @Input() set value(value: string) {
    this._value = value;
    if (this.buttons) {
      this.buttons.forEach((button) => {
        button.active = button.value === value;
      });
    }
  }

  get value () {
    return this._value;
  }


  ngAfterContentInit() {
    this.value = this._value;
    this.buttons.forEach((button) => {
      button.clicked.subscribe((value) => {
        this.value = value;
        this.change.emit(this.value);
      });
    });

  }


}
